/**
 * Detail-page live-sync diagnostics.
 * Enable: localStorage.setItem('sgrc:detail-sync-debug', '1'); location.reload();
 */
import { Logger } from '@/lib/app-log.js';

const STORAGE_KEY = 'sgrc:detail-sync-debug';
const LEGACY_STORAGE_KEY = 'sgrc:asset-detail-sync-debug';

export function isReferenceDetailSyncDebugEnabled() {
    if (typeof window === 'undefined') return false;
    try {
        if (window.__SGRC_DETAIL_SYNC_DEBUG__ === true) return true;
        if (window.__SGRC_ASSET_DETAIL_SYNC_DEBUG__ === true) return true;
        return (
            localStorage.getItem(STORAGE_KEY) === '1'
            || localStorage.getItem(LEGACY_STORAGE_KEY) === '1'
        );
    } catch {
        return false;
    }
}

/**
 * @param {string} scope
 * @param {string} message
 * @param {Record<string, unknown>} [data]
 */
export function logReferenceDetailSync(scope, message, data) {
    if (!isReferenceDetailSyncDebugEnabled()) return;
    const ts = new Date().toISOString();
    if (data && Object.keys(data).length > 0) {
        Logger.info(`[DetailSync:${scope}] ${message}`, { ts, ...data });
    } else {
        Logger.info(`[DetailSync:${scope}] ${message}`, { ts });
    }
}

/** @deprecated Use logReferenceDetailSync */
export const logAssetDetailSync = logReferenceDetailSync;

/** @deprecated Use isReferenceDetailSyncDebugEnabled */
export const isAssetDetailSyncDebugEnabled = isReferenceDetailSyncDebugEnabled;
